import axios from "../../config/interceptor";
import { PER_PAGE_SIZE } from "../../utils/constants";

export const postCategoryItem = async (data) => {
  try {
    const response = await axios.post(
      `/lambda/v1/categories-item`,
      data
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const putCategoryItem = async (data) => {
  try {
    const response = await axios.put(
      `/lambda/v1/categories-item/${data.id}`,
      data
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getCategoryItems = async ({
  page = 0,
  size = PER_PAGE_SIZE,
  businessId,
}) => {
  try {
    let link =
      `/lambda/v1/categories-item/${businessId}?`;
    link = link.concat("page=" + page);
    link = link.concat("&size=" + size);

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};

export const getCategoryItemDetail = async (id) => {
  try {
    const response = await axios.get(
      `/lambda/v1/categories-item/detail/${id}`
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const deleteCategoryItem = async (id) => {
  try {
    const response = await axios.delete(
      `/lambda/v1/categories-item/${id}`
    );

    return response;
  } catch (error) {
    return error;
  }
};
